import type { Database } from '../lib/adatbazis.ts';
import type { LeadStatusz } from '../lib/tipusok.ts';

export type LeadUpdate = Database['public']['Tables']['leads']['Update'];
export interface StatuszMezok {
  szemleIdopont: string | null; megbizasTipus: 'kizarolagos' | 'nem_kizarolagos' | null;
  tenylegesAr: number | null; elveszettOk: string | null; ujrahivasHonap: string | null;
}
export const VALASZTHATO_STATUSZOK: LeadStatusz[] = ['uj', 'elerve', 'kesobb_aktualis', 'szemle_egyeztetve', 'szemle_megtortent', 'megbizas', 'eladva', 'elveszett'];

export function statuszValtasHiba(cel: LeadStatusz, m: StatuszMezok): string | null {
  if (cel === 'szemle_egyeztetve' && !m.szemleIdopont) return 'Add meg a szemle időpontját.';
  if (cel === 'kesobb_aktualis' && !m.ujrahivasHonap) return 'Válaszd ki, mikor keressük újra.';
  if (cel === 'megbizas' && !m.megbizasTipus) return 'Válaszd ki a megbízás típusát.';
  if (cel === 'eladva' && !(m.tenylegesAr && m.tenylegesAr > 0)) return 'Add meg a tényleges eladási árat.';
  if (cel === 'elveszett' && !m.elveszettOk) return 'Válaszd ki, miért veszett el.';
  return null;
}

export function statuszFrissites(cel: LeadStatusz, m: StatuszMezok): LeadUpdate {
  if (cel === 'szemle_egyeztetve') return { statusz: cel, szemle_idopont: m.szemleIdopont };
  if (cel === 'kesobb_aktualis') return { statusz: cel, ujrahivas_honap: m.ujrahivasHonap };
  if (cel === 'megbizas') return { statusz: cel, megbizas_tipus: m.megbizasTipus };
  if (cel === 'eladva') return { statusz: cel, tenyleges_ar: m.tenylegesAr };
  if (cel === 'elveszett') return { statusz: cel, elveszett_ok: m.elveszettOk };
  return { statusz: cel };
}
